import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    autoDismiss: Number
  }

  connect() {
    if (this.hasAutoDismissValue && this.autoDismissValue > 0) {
      this.autoDismissTimeout = setTimeout(() => {
        this.dismiss()
      }, this.autoDismissValue)
    }
  }

  disconnect() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }
  }

  dismiss(event) {
    if (event) {
      event.preventDefault()
    }

    // Dispatch custom event for analytics or other listeners
    this.element.dispatchEvent(new CustomEvent('admin-notification:dismiss', {
      bubbles: true,
      detail: { element: this.element }
    }))

    // Fade out animation
    this.element.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out'
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateX(100%)'

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
